
/* eslint consistent-return: 0 */

import isEmpty from 'lodash/isEmpty';

/** */


/** */


/** */


/**
 * Format experiment metadata
*/
export default function experimentMetadata(input) {
  var _ref = (input || {}).experimentMetadata || {},
      errors = _ref.errors,
      assignmentId = _ref.assignmentId,
      requestTimestamp = _ref.requestTimestamp;

  var formattedExperimentMetadata = {};
  if (errors && errors.length) {
    formattedExperimentMetadata.errors = errors;
  }
  if (assignmentId) {
    formattedExperimentMetadata.assignmentId = assignmentId;
  }
  if (requestTimestamp) {
    formattedExperimentMetadata.requestTimestamp = requestTimestamp;
  }

  return isEmpty(formattedExperimentMetadata) ? undefined : formattedExperimentMetadata;
}

export function defaultValue() {}